module.exports = __webpack_public_path__ + "static/media/dolly.803bac5a.svg";